import { render } from "./IconBulletListItem.vue?vue&type=template&id=14c85c6c"
const script = {}
script.render = render

export default script